import Pagination, { type PaginationProps } from '@mui/material/Pagination';
import TablePagination, { type TablePaginationProps } from '@mui/material/TablePagination';
import {
  type DataGridProps,
  type GridActionsCellItemProps,
  type GridOverlayProps,
  type GridCellParams,
  type GridColDef,
  type GridRenderCellParams,
  type GridRenderEditCellParams,
  type GridSortingInitialState,
  type GridValidRowModel,
  type GridEventListener,
  type GridSortModel,
  type GridRowParams,
  type GridRowSelectionModel,
  DataGrid,
  GridActionsCellItem,
  GridOverlay,
  useGridApiRef,
  gridFilteredSortedRowIdsSelector,
} from '@mui/x-data-grid';

declare module '@mui/x-data-grid' {
  interface FooterPropsOverrides {
    total: number;
    pagination: TablePaginationProps | PaginationProps;
  }
}

const dataGridSortDirection = ['asc', 'desc'] as const;

export { DataGrid, GridActionsCellItem, GridOverlay, TablePagination, Pagination };
export type { TablePaginationProps, PaginationProps };
export type {
  DataGridProps,
  GridActionsCellItemProps,
  GridOverlayProps,
  GridCellParams,
  GridColDef,
  GridRenderCellParams,
  GridRenderEditCellParams,
  GridSortingInitialState,
  GridValidRowModel,
  GridEventListener,
  GridSortModel,
  GridRowParams,
  GridRowSelectionModel,
};
export { useGridApiRef, gridFilteredSortedRowIdsSelector, dataGridSortDirection };
